"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useFieldContext = _interopRequireDefault(require("../../../../hooks/useFieldContext"));
var _react = require("react");
var _uuid = require("uuid");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Custom = function Custom(props) {
  var validationFunction = props.validationFunction,
    validateOnChange = props.validateOnChange;
  var uuid = (0, _react.useState)((0, _uuid.v4)())[0];
  var _a = (0, _useFieldContext.default)(),
    addValidation = _a.addValidation,
    removeValidation = _a.removeValidation,
    fieldContextValidateOnChange = _a.validateOnChange;
  (0, _react.useEffect)(function () {
    addValidation("custom_field_".concat(uuid), validationFunction, validateOnChange || fieldContextValidateOnChange);
    return function () {
      removeValidation("custom_field_".concat(uuid));
    };
  }, [addValidation, fieldContextValidateOnChange, removeValidation, uuid, validateOnChange, validationFunction]);
  return null;
};
var _default = Custom;
exports.default = _default;